import './styles.scss';

const MainPage = () => {
    return(
        <h6>Selecione a rotina desejada</h6>
    )

}

export default MainPage